// extracted by mini-css-extract-plugin
module.exports = {"Btn":"CustomConfirm_Btn__1wst2","Btns":"CustomConfirm_Btns__32FKL","BtnConfirm":"CustomConfirm_BtnConfirm__1Ij79"};